class Login extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
  }
  connectedCallback() {
    this.toggleVisiblePassword();
    this.setLoginEmail();
  }
  setLoginEmail() {
    if (localStorage && localStorage.getItem("lo_e")) {
      this.querySelector('input[name="email"]').value = atob(localStorage.getItem("lo_e"));
    }
  }
  checkShowable() {
    var _a;
    const loginElement = document.querySelector("w3-login#login");
    const { search } = document.location;
    const is_email_exists_error = search && search.indexOf("?email_error_exists=true") !== -1;
    const login_success_reset_display = (_a = loginElement.querySelector("#ResetSuccess")) == null ? void 0 : _a.style.display;
    const login_errors = loginElement.querySelectorAll(".errors");
    const recover_errors = loginElement.querySelectorAll(".errors");
    console.log(login_success_reset_display);
    console.log(login_errors.length);
    console.log(recover_errors.length);
    console.log(is_email_exists_error);
    if (login_success_reset_display !== "none" || login_errors.length >= 2 || recover_errors.length || is_email_exists_error) {
      history.pushState({}, "", "#login");
      history.back();
      let onpopstate = window.onpopstate;
      window.onpopstate = function() {
        history.forward();
        window.onpopstate = onpopstate;
      };
    }
  }
  fillEmailField(email) {
    if (this.validateEmail(email)) {
      this.form.querySelector('input[name="customer[email]"]').value = email;
    }
  }
  validateEmail(string) {
    return String(string).toLowerCase().match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
  clearPasswordField() {
    this.form.querySelector('input[name="customer[password]"]').value = "";
  }
  toggleVisiblePassword() {
    const passwordFieldWrappers = this.form.querySelector(".js-password-field-wrapper");
    const input = passwordFieldWrappers.querySelector("input");
    const eyeOpen = passwordFieldWrappers.querySelector(".show-password");
    const eyeClosed = passwordFieldWrappers.querySelector(".hide-password");
    eyeOpen.addEventListener("click", (e) => {
      e.preventDefault();
      input.type = "text";
      eyeClosed.style.display = "flex";
      eyeOpen.style.display = "none";
    });
    eyeClosed.addEventListener("click", (e) => {
      e.preventDefault();
      input.type = "password";
      eyeOpen.style.display = "flex";
      eyeClosed.style.display = "none";
    });
  }
}
customElements.define("w3-login", Login);
